var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('el-container',[_c('el-header',[_c('lay-header')],1),_c('el-container',[_c('el-aside',[_c('lay-nav')],1),_c('el-main',[_c('lay-main')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }